module.exports = __webpack_public_path__ + "img/SJCX-alt.267d9b5b.svg";